// src/PdfComparisonComponent.js
import React, { useEffect, useState } from "react";
import PdfViewerComponent from "./PdfViewerComponent";
import Sidebar from "./TableOfContent";

function PdfComparisonComponent(props) {
  const { file1, file2 } = props;

  return (
    <div className="flex w-full ">
      <div className="w-full ">
        {file1 && (
          <PdfViewerComponent
            searchPluginInstance={props.searchPluginInstance}
            pageNumber={props.pageNumber}
            file1={file1}
            file2={file2}
            zoomPluginInstance={props.zoomPluginInstance}
            zoomPluginInstance2={props.zoomPluginInstance2}
            syncScroll={props.syncScroll}
          />
        )}
      </div>
    </div>
  );
}

export default PdfComparisonComponent;
